import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-statistics-total',
  templateUrl: './statistics-total.component.html',
  styleUrls: ['./statistics-total.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StatisticsTotalComponent {
  // disabled rule because of inconsistencies of series types in echarts
  // (no defined label, but supported)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() totalData: any;
  @Input() titleKey: string;
}
